import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { TextField, Checkbox } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { sendContact } from "../../services";
import toast from "react-hot-toast";
import CircularProgress from "@mui/material/CircularProgress";

export const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    return;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const res = await sendContact(data);

    if (res?.status === true) {
      toast.success(res.message);
      setLoading(false);
      return;
    }
    toast.error("Something went wrong, please try again later.");
    setLoading(false);
    return;
  };

  return (
    <Box
      sx={{
        mt: 5,
        p: 3,
        boxShadow: 3,
        borderRadius: 2,
        backgroundColor: "#fff",
      }}
    >
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Name"
              variant="outlined"
              required
              name="name"
              value={data?.name || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              variant="outlined"
              required
              name="email"
              value={data?.email || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Phone"
              type="tel"
              variant="outlined"
              name="phn"
              value={data?.phn || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Message"
              multiline
              rows={4}
              variant="outlined"
              required
              name="message"
              value={data?.message || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              className="checkbox"
              required
              control={<Checkbox />}
              label="I understand that my information will be stored and used solely to respond to my inquiry."
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              className="btn-primary w-100"
              type="submit"
              variant="contained"
              color="primary"
              size="large"
            >
              {loading ? <CircularProgress size={20} /> : "Send Message"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};
